import { ActionTypes } from "../../constants/ActionTypes";
import { IGetContacts } from "../../interfaces/Contact";

export const onGetConatcts = (params: IGetContacts) => {
  return {
    type: ActionTypes.GET_CONTACTS,
    payload: params,
  };
};

export const fetchConatctsSuccess = (contactsList: any[]) => {
  return {
    type: ActionTypes.FETCH_CONTACTS_SUCCESS,
    payload: contactsList,
  };
};

export const onGetReceivers = (searchText: string | undefined) => {
  return {
    type: ActionTypes.GET_RECEIVERS_LIST,
    payload: searchText,
  };
};

export const fetchReceiversListSuccess = (receiversList: any[]) => {
  return {
    type: ActionTypes.FETCH_RECEIVERS_LIST_SUCCESS,
    payload: receiversList,
  };
};

export const onGetAllContact = () => {
  return (dispatch: any) => {
    dispatch({ type: ActionTypes.FETCH_START });
    dispatch({ type: ActionTypes.FETCH_SUCCESS });
    dispatch({
      type: ActionTypes.GET_All_CONTACT_SUCCESS,
      payload: null,
    });
  };
};

export const onAddContact = (contact: string) => { };

export const onUpdateContact = (id: string, contact: string) => { };

export const onDeleteContact = (id: string) => { };
